import { useMenuConfig } from '@/features/navigation/hooks/useMenuConfig';
import { Navigate } from 'react-router';

export const HomeRedirect = () => {
  const { homeRedirect, isReady } = useMenuConfig();

  if (!isReady) return null;
  if (!homeRedirect) return null;

  return <Navigate to={homeRedirect} replace />;
};
